<template>
  <div>
    <div class="bg-indigo-600">
      <div class="max-w-screen-xl mx-auto py-1 px-2 sm:px-6 lg:px-4">
        <div class="flex items-center justify-between flex-wrap">
          <div class="w-0 flex-1 flex items-center">
            <p class="ml-3 font-medium text-xs text-white truncate">
              <span class="md:hidden"> We announced a new product! </span>
              <span class="hidden md:inline">
                Big news! We're excited to announce a brand new product.
              </span>
            </p>
          </div>
          <div
            class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto"
          >
            <div class="rounded-md shadow-sm">
              <a
                href="#"
                class="flex items-center text-xs justify-center px-2 py-1 border border-transparent text-xs leading-5 font-medium rounded-md text-indigo-600 bg-white hover:text-indigo-500 focus:outline-none focus:shadow-outline transition ease-in-out duration-150"
              >
                Learn more
              </a>
            </div>
          </div>
          <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
            <button
              type="button"
              class="-mr-1 flex p-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:bg-indigo-500 sm:-mr-2 transition ease-in-out duration-150"
              aria-label="Dismiss"
            >
              <!-- Heroicon name: x -->
              <svg
                class="h-6 w-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class ScreenAlert extends Vue {
  private settings = {
    userDropdown: false,
    notificationDropdown: false,
  };

  viewUserDropdown() {
    this.settings.userDropdown = true;
  }

  hideUserDropdown() {
    this.settings.userDropdown = false;
  }

  viewNotifications() {
    this.settings.notificationDropdown = true;
  }

  hideNotifications() {
    this.settings.notificationDropdown = false;
  }
}
</script>
